import { ARTICLE_MODEL_CLASS_NAME, ARTICLES_MODEL_ASSOCIATIONS_ISOLATE } from 'models/daos/article/constants'
import { MOTIVATION_MODEL_ASSOCIATIONS_ISOLATE, MOTIVATION_MODEL_CLASS_NAME } from 'models/daos/motivation/constants'

/**
 * A mapping of className to list of isolated associated keys.
 * @type {Object}
 */
const MODEL_ASSOCIATIONS_ISOLATE = {
  [ARTICLE_MODEL_CLASS_NAME]: ARTICLES_MODEL_ASSOCIATIONS_ISOLATE,
  [MOTIVATION_MODEL_CLASS_NAME]: MOTIVATION_MODEL_ASSOCIATIONS_ISOLATE
}

/**
 * Gets the isolated association keys of the given className.
 * @param  {string} className
 * @returns {string[]}
 */
function getIsolatedAssociationKeysFromClassNameModelUtil (className) {
  return MODEL_ASSOCIATIONS_ISOLATE[className] || []
}

export {
  getIsolatedAssociationKeysFromClassNameModelUtil
}
